<template>
    <modal
        v-if="popup.component"
        :show="popup.show"
        :title="popup.title"
        :needFooter="false"
        :centered="true"
        size="large"
        class="modal-identify-viewer"
        :class="className"
        bodyClass="overflowY"
        @close="onClosePopup">

            <template slot="modal-header-actions" v-if="displayPrint && !startedProcess" >
                <button type="button" title="Imprimir" @click="onPrint" class="btn btn-link min-w-auto m-0 btn-lg py-0 px-2 z-depth-0" data-dismiss="modal" aria-label="Print">
                    <i class="fas fa-print"></i>
                </button>
            </template>

            <div class="flex-column flex-fill h-100" :class="[displayPrint && !startedProcess || !displayPrint ? 'd-flex' : 'd-none']">
                <component
                    class="overflowHiddenX"
                    :is="popup.component"
                    :url="popup.url"
                    :useProxy="false"
                    @error="onInfoError"
                />
            </div>

            <div
                v-if="displayPrint"
                class="panel-control flex-column flex-fill h-100"
                :class="[startedProcess ? 'd-flex': 'd-none']">
                <div class="panel-control-content d-flex flex-column flex-fill">
                    <!-- PROCESS WORKFLOW -->
                    <print-process-workflow
                        v-if="startedProcess"
                        :description="printDescription"
                        :titleList="printTitleList"
                        :emptyResult="printEmptyResult"
                        :url="print.url.status"
                        :id="idProcess"
                        :canceled="print.canceled"
                        :showBtnClose="print.showBtnClose"
                        :titleBtnClose="print.titleBtnClose"
                        @close="onClosePrint"
                    >
                    </print-process-workflow>
                </div>
            </div>
    </modal>
</template>

<script>
    import {isObject, formatString, formatUrl} from '@config/utils'
    import GlobalMixin from '@/app/shared/mixins/global';
    import ProcessJobMixin from '@/app/shared/components/workflow/mixins/ProcessJobMixin';
    import FormViewer from '@/components/maps/shared/identify/viewers/popup/FormPropertiesViewer';

    export default
    {
        name: 'identifyInfoModal',
        mixins: [
            GlobalMixin,
            ProcessJobMixin,
        ],
        components:
        {
            Modal: () => import(/* webpackChunkName: "modal" */ '@/app/shared/components/modals/Modal'),
            PrintProcessWorkflow: () => import(/* webpackChunkName: "common-process-workflow" */ '@/app/shared/components/workflow/CommonProcessWorkflow'),
        },
        props: {
            moduleCode: {
                type: String,
                require: true,
            },
            url: {
                type: [String, Object],
                required: false
            },
            component: {
                type: Object,
                default: () => {return FormViewer},
            },
            popupTitle: {
                type: String,
                default: null,
            },
            // propTitle: {
            //     type: String,
            //     default: null,
            // },
            enablePrint: {
                type: Boolean,
                default: false
            },
            urlPrint: {
                type: Object,
                required: false
            },
            printDescription: {
                type: String,
                default: '',
            },
            printTitleList: {
                type: String,
                default: '',
            },
            printEmptyResult: {
                type: String,
                default: 'Não foram impressos documentos.',
            },
        },
        data() {
            return {
                popup: {
                    id: null,
                    show: false,
                    title: null,
                    baseUrl: null,
                    url: null,
                    component: null,
                    params: null,
                    feature: null,
                },
                form: {},
                print: {
                    enable: false,
                    loading: false,
                    url: {create: null, status: null},
                    showBtnClose: true,
                    titleBtnClose: 'Voltar',
                    canceled: false,
                    form: {},
                }
            }
        },
        mounted() {
            this.initialize();
        },
        computed: {
            baseUrl() {
                return isObject(this.popup.baseUrl) ? this.popup.baseUrl.urlObject : this.popup.baseUrl;
            },
            displayPrint() {
                return this.print.enable;
            },
            className() {
                let cls = [];
                let params = this.popup.params || {};
                if(params && params.class) {
                    cls.push(params.class);
                }
                return cls.filter(el => !!el).join(' ');
            },
        },
        methods: {
            initialize() {
                if(this.urlPrint) {
                    this.print.url = Object.assign(this.print.url, this.urlPrint);
                    this.print.enable = this.enablePrint;
                }
                this.setComponent(this.component);
                this.setBaseUrl(this.url);
            },
            onOpenPopup(feature, title= null, url=null, forceDisablePrint=false, params={}, tools={}) {
                // FOR DINAMIC URL
                if(url){
                    this.setBaseUrl(url);
                }

                this.setConfigTools(tools);

                if(forceDisablePrint){
                    this.print.enable = false;
                }

                if(this.baseUrl){
                    let properties = feature?.properties ?? feature ?? {};
                    // this.popup.id = id;
                    this.popup.feature = feature;
                    this.popup.title = title;
                    this.popup.url = formatUrl(new String(this.baseUrl), properties, '{', '}');
                    this.popup.params = params;
                    this.popup.show = true;
                    // this.popup.component = FormViewer;
                }
            },
            onClosePopup() {
                Object.assign(this.$data.popup, this.$options.data().popup);
                this.onClosePrint();
                this.initialize();
                this.$emit('close');
            },
            // getPopupTitle(id) {
            //     return !isEmpty(this.popupTitle) ? this.popupTitle : (!isEmpty(this.propTitle) ? `${this.propTitle}: ${id}` : `${id}`);
            // },
            onInfoError(){

            },
            setConfigTools(tools) {
                this.print.enable = this.enablePrint;

                let printTool = tools?.print ?? {};
                Object.assign(this.print, printTool);
            },
            onPrint: function() {
                let feature = this.popup.feature;
                if(feature){
                    this.startProcess(feature);
                }
            },
            setLoadingPrint: function(flag){
                this.print.loading = flag;
                this.$emit('loading', flag);
            },
            resetPrint: function() {
                Object.assign(this.$data.form, this.$options.data().form);
                this.resetJob();
            },
            cancelPrint: function() {
                this.print.canceled = true;
            },
            onClosePrint: function(){
                this.cancelPrint();
                this.resetPrint();
            },
            startProcess: function(feature) {
                let url = this.print.url?.create;
                if(!url){
                    return;
                }

                try {
                    this.setLoadingPrint(true);

                    this.clearMessages();
                    this.$validator.validateAll().then(result => {
                        if(!result){
                            this.showError('global.msg.error.form');
                            return;
                        }

                        let properties = feature?.properties ?? feature ?? {};
                        let form = this.print.form ?? this.form;
                        Object.keys(form).forEach(function(key){ form[key] = formatString(form[key], properties, '{', '}') });

                        this.$http.post(formatUrl(url, properties, '{', '}'), form)
                        .then( res => {
                            let data = res.data.data;
                            if(data && data.jobId){
                                this.job.id = data.jobId;
                            }else{
                                this.showError(data);
                            }
                        })
                        .catch( error => {
                            this.showHttpError(error);
                        })
                        .finally(() => this.setLoadingPrint(false))
                    });
                }
                catch(err) {
                    this.showError(err);
                }
                finally {
                    this.setLoadingPrint(false);
                }
            },
            setComponent: function(component) {
                this.popup.component = component;
            },
            setBaseUrl: function(url) {
                this.popup.baseUrl = url;
            },
            onPrintContent: function() {
                // [TODO]
                // const prtHtml = document.getElementById('print').innerHTML;

                // // Get all stylesheets HTML
                // let stylesHtml = '';
                // for (const node of [...document.querySelectorAll('link[rel="stylesheet"], style')]) {
                // stylesHtml += node.outerHTML;
                // }

                // // Open the print window
                // const WinPrint = window.open('', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0');

                // WinPrint.document.write(`<!DOCTYPE html>
                // <html>
                // <head>
                //     ${stylesHtml}
                // </head>
                // <body>
                //     ${prtHtml}
                // </body>
                // </html>`);

                // WinPrint.document.close();
                // WinPrint.focus();
                // WinPrint.print();
                // WinPrint.close();
            },
        },
        watch: {
            component (value) {
                this.setComponent(value);
            },
            url (value) {
                this.setBaseUrl(value);
            },
        },
    }
</script>

<style scoped lang="scss">

</style>